<span
  class="chart-type"
  [class.chart-type-small]="isNeedBurgerMenu"
  [ivLiveHint]="chartName"
  ivLiveHintPosition="top-right"
  #chartNameSpan
>
  {{chartName}}
</span>

<div
  class="controls"
  [formGroup]="form"
  #controls
>
  <div class="controls__form" #chartControls>
    <ng-container *ngIf="card.chartId !== chartNameId.IV_DIFFERENCE">
      <ng-container *ngTemplateOutlet="baseStock"></ng-container>
    </ng-container>

    <ng-container *ngIf="card.chartId === chartNameId.IV_DIFFERENCE">
      <div class="controls-frame">
        <span class="controls-frame__title">{{locale.firstPoint}}</span>

        <ng-container *ngIf="form.get(filterTypes.STOCK_ID + '-first')">
          <ng-container *ngTemplateOutlet="ivDifferentStock; context: {stock: form.get(filterTypes.STOCK_ID + '-first').value, point: 'first'}"></ng-container>
        </ng-container>

        <ng-container *ngIf="form.get(filterTypes.IVX_TERM + '-first')">
          <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.IVX_TERM + '-first'}"></ng-container>
        </ng-container>

        <ng-container *ngIf="form.get(filterTypes.MONEYNESS + '-first')">
          <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.MONEYNESS + '-first'}"></ng-container>
        </ng-container>
      </div>

      <div class="controls-frame">
        <span class="controls-frame__title">{{locale.secondPoint}}</span>

        <ng-container *ngIf="form.get(filterTypes.STOCK_ID + '-second')">
          <ng-container *ngTemplateOutlet="ivDifferentStock; context: {stock: form.get(filterTypes.STOCK_ID + '-second').value, point: 'second'}"></ng-container>
        </ng-container>

        <ng-container *ngIf="form.get(filterTypes.IVX_TERM + '-second')">
          <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.IVX_TERM + '-second'}"></ng-container>
        </ng-container>

        <ng-container *ngIf="form.get(filterTypes.MONEYNESS + '-second')">
          <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.MONEYNESS + '-second'}"></ng-container>
        </ng-container>
      </div>
    </ng-container>

    <ng-container>
      <ng-container *ngTemplateOutlet="compareStock"></ng-container>
    </ng-container>

    <!-- TODO: Когда TIME_RANGE будет больше D1 для SINGLE_CONTRACT_ANALYZER -> убрать -->
    <ng-container *ngIf="form.get(filterTypes.TIME_RANGE) && card.chartId !== chartNameId.SINGLE_CONTRACT_ANALYZER">
      <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.TIME_RANGE}"></ng-container>
    </ng-container>

    <ng-container *ngIf="form.get(filterTypes.EOD_TIME_RANGE)">
      <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.EOD_TIME_RANGE}"></ng-container>
    </ng-container>

    <ng-container *ngIf="form.get(filterTypes.V_MODE_TOGGLER)">
      <ng-container *ngTemplateOutlet="vWapToggle"></ng-container>
    </ng-container>

    <ng-container *ngIf="form.get(filterTypes.IVX_TERM)">
      <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.IVX_TERM}"></ng-container>
    </ng-container>

    <ng-container *ngIf="form.get(filterTypes.OPTION_TYPE)">
      <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.OPTION_TYPE}"></ng-container>
    </ng-container>

    <ng-container *ngIf="form.get(filterTypes.TOTAL_OI_CHART_TYPE)">
      <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.TOTAL_OI_CHART_TYPE}"></ng-container>
    </ng-container>

    <ng-container *ngIf="form.get(filterTypes.HV_TERM)">
      <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.HV_TERM}"></ng-container>
    </ng-container>

    <ng-container *ngIf="form.get(filterTypes.MONEYNESS)">
      <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.MONEYNESS}"></ng-container>
    </ng-container>

    <ng-container *ngIf="form.get(filterTypes.DATE_TIME)">
      <ng-container *ngTemplateOutlet="dateTimePicker"></ng-container>
    </ng-container>

    <ng-container *ngIf="form.get(filterTypes.EXPIRATION_DATE)">
      <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.EXPIRATION_DATE}"></ng-container>
    </ng-container>

    <ng-container *ngIf="form.get(filterTypes.STRIKE)">
      <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.STRIKE}"></ng-container>
    </ng-container>

    <ng-container *ngIf="form.get(filterTypes.SINGLE_CONTRACT_ANALYZER_TYPE)">
      <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.SINGLE_CONTRACT_ANALYZER_TYPE}"></ng-container>
    </ng-container>

    <ng-container *ngIf="form.get(filterTypes.REALTIME)">
      <ng-container *ngTemplateOutlet="realtime"></ng-container>
    </ng-container>

    <ng-container *ngTemplateOutlet="screenshot"></ng-container>

    <ng-container *ngTemplateOutlet="fullScreen"></ng-container>

    <!--    TODO: Процентный режим временно скрыт -->
    <!--    <ng-container *ngTemplateOutlet="relative"></ng-container>-->
  </div>

  <ng-container *ngTemplateOutlet="burgerMenu"></ng-container>

  <ng-container *ngTemplateOutlet="close"></ng-container>
</div>

<ng-template #baseStock>
  <div
    class="controls__main-series action-control-common"
    [ivLiveHint]="locale.mainSeries"
    ivLiveHintPosition="top-center"
    (click)="changeSeries(card.id, mainSeries.id)"
    statistic
    [statisticElementName]="'Card chart control select main series'"
  >
    {{mainSeries.stock.symbol}}
  </div>
</ng-template>

<ng-template #ivDifferentStock let-stock="stock" let-point="point">
  <div
    class="controls__main-series action-control-common"
    [ivLiveHint]="locale.changeIvDiffStock"
    ivLiveHintPosition="top-right"
    (click)="changeIVDiffStockSeries(card.id, mainSeries.id, point)"
    statistic
    [statisticElementName]="'Card chart control select main series'"
  >
    {{stock.symbol}}
  </div>
</ng-template>

<ng-template #compareStock>
  <div
    class="controls__compare action-control-common"
    [class.controls__compare-display-none]="card.chartSeries.length === maxCountSeries"
    [class.controls__compare-before-none]="card.chartId === chartNameId.IV_DIFFERENCE"
    [ivLiveHint]="locale.compareHint"
    ivLiveHintPosition="top-right"
    (click)="compareButtonFunc"
    statistic
    [statisticElementName]="'Compare card chart control'"
  >
    <img src="./iv-live/assets/icons/chart-service/charts-icons/compare.svg" alt="compare"/>
    <span>{{locale.compare}} </span>
  </div>
</ng-template>

<ng-template #dropdown let-controlName="controlName">
  <ng-container [formGroup]="form">
    <iv-live-dropdown-new
      class="controls__chart-filter action-control-common"
      [withoutHover]="true"
      [formControlName]="controlName"
      [listValues]="$any(getChartFilter(controlName).pattern)"
      [templateField]="dropdownTemplateField(controlName)"
      [rubberInput]="true"
      [ivLiveHint]="locale[controlName]"
      [contentWidth]="contentWidth(controlName)"
      ivLiveHintPosition="top-right"
      withoutDivider
      [label]="getFilterLabel(controlName)"
      [isAutocomplete]="controlName === 'strike'"
    ></iv-live-dropdown-new>
  </ng-container>
</ng-template>

<ng-template #dateTimePicker>
  <ng-container [formGroup]="form">
    <iv-live-date-time-selector
      class="controls__date-time-picker action-control-common"
      [class.controls__date-time-picker-disable]="form.get(filterTypes.DATE_TIME).disabled"
      [formControlName]="filterTypes.DATE_TIME"
      [locale]="locale"
      [isActionControl]="true"
      [clearButton]="{date: false, time: false}"
      [container]="isFullScreen ? controls : undefined"
      (isEod)="dateIsEod($event)"
    ></iv-live-date-time-selector>
  </ng-container>
</ng-template>

<ng-template #vWapToggle>
  <ng-container [formGroup]="form">
    <div
      tuiHintMode="onDark"
      tuiHintDirection="top-right"
      [tuiHint]="form.get(filterTypes.V_MODE_TOGGLER).disabled ? locale.vWapHintNoData : locale.vWapHint"
    >
      <tui-checkbox-labeled
        class="controls__v_mode action-control-common"
        [formControlName]="filterTypes.V_MODE_TOGGLER"
        (click)="onVMode()"
      >
        {{locale.vWap}}
      </tui-checkbox-labeled>
    </div>
  </ng-container>
</ng-template>

<ng-template #realtime>
  <div
    class="controls__auto-update action-control-common"
    [class.controls__auto-update-disabled]="form.get(filterTypes.REALTIME).disabled"
    (click)="toggleRtMode()"
    statistic
    [statisticElementName]="'Toggle rt mode card chart control'"
    [ivLiveHint]="locale.rt"
    ivLiveHintPosition="top-center"
  >
    <div class="icon">
      <img
        class="icon__on"
        *ngIf="form.get(filterTypes.REALTIME).value.name === realtimeToggle.ON"
        src="./iv-live/assets/icons/chart-service/charts-icons/on-rt-mode.svg" alt="rtMode"/>
      <img
        class="icon__off"
        *ngIf="form.get(filterTypes.REALTIME).value.name === realtimeToggle.OFF"
        src="./iv-live/assets/icons/chart-service/charts-icons/off-rt-mode.svg" alt="rtMode"/>
    </div>

    <span
      class="iv-switcher auto-update-toggle"
      [class.active]="form.get(filterTypes.REALTIME).value.name === realtimeToggle.ON"
    ></span>
  </div>
</ng-template>

<!--    TODO: Процентный режим временно скрыт -->
<!--<ng-template #relative>-->
<!--  <div-->
<!--    class="controls__relative action-control-common"-->
<!--    [ivLiveHint]="locale.relativeMode"-->
<!--    ivLiveHintPosition="top-right"-->
<!--    (click)="toggleRelative()"-->
<!--  >-->
<!--    <img *ngIf="form.get(filterTypes.RELATIVE_MODE).value"-->
<!--         src="./iv-live/assets/icons/chart-service/charts-icons/relative-on.svg" alt="relative"/>-->
<!--    <img *ngIf="!form.get(filterTypes.RELATIVE_MODE).value"-->
<!--         src="./iv-live/assets/icons/chart-service/charts-icons/relative.svg" alt="relative-on"/>-->
<!--  </div>-->
<!--</ng-template>-->

<ng-template #screenshot>
  <div
    class="controls__screenshot action-control-common"
    [ivLiveHint]="locale.screenshot"
    ivLiveHintPosition="top-center"
    statistic
    [statisticElementName]="'Save a screenshot of the chart'"
    (click)="takeScreenshot()"
  >
    <img src="./iv-live/assets/icons/chart-service/charts-icons/screenshot.svg" alt="screenshot"/>
  </div>
</ng-template>

<ng-template #fullScreen>
  <div
    class="controls__full-screen action-control-common"
    [ivLiveHint]="locale.fullScreen"
    ivLiveHintPosition="top-center"
    statistic
    [statisticElementName]="'Open full screen card chart control'"
    (click)="toggleFullScreen()"
  >
    <img src="./iv-live/assets/icons/chart-service/charts-icons/fullscreen.svg" alt="full-screen"/>
  </div>
</ng-template>

<ng-template #burgerMenu>
  <div
    *ngIf="isNeedBurgerMenu"
    class="controls__burger-menu"
  >
    <div
      class="action-control-common"
      statistic
      [statisticElementName]="'On click burger-menu card chart controls'"
      (click)="toggleBurgerMenu()"
    >
      <img src="./iv-live/assets/icons/chart-service/charts-icons/burger-menu.svg" alt="burger-menu">
    </div>

    <div
      class="burger-menu-list"
      [class.burger-menu-list-hidden]="isBurgerMenuClosed"
      #burgerMenuControls
    ></div>
  </div>
</ng-template>

<ng-template #close>
  <div
    class="controls__close-chart action-control-common"
    [ivLiveHint]="locale.close"
    ivLiveHintPosition="top-left"
    statistic
    [statisticElementName]="'Card chart control delete chart'"
    (click)="deleteChartLayout(card.id)"
  >
    <img src="./iv-live/assets/icons/chart-service/charts-icons/close.svg" alt="close">
  </div>
</ng-template>
